export default "__VITE_ASSET__orZaJlIR__"